import { api } from '@shared/api/api';
import { toQueryString } from '@shared/api/helpers';
import { PaginatedResourceResponse, PartialQuery } from '@shared/api/types';

type ParkingRequest = App.Domain.Parking.Data.ParkingRequestData;

export function getParkingRequests(registrationId: number, query?: PartialQuery) {
  const baseUrl = `registrations/${registrationId}/parking-requests`;

  const url = query ? `${baseUrl}?${toQueryString(query)}` : baseUrl;

  return api.get<PaginatedResourceResponse<ParkingRequest>>(url);
}
